// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lang-flag[data-v-64104bce]{width:1.5rem;height:1.5rem}
`, "",{"version":3,"sources":["webpack://./src/common/components/footer/TFooterActionsRight.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,CACb,aAAc","sourcesContent":["\n.lang-flag {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
